import React from "react";
import type { ICellRendererParams } from "@/ui/molecules/Grid";
import Box from "@/ui/atoms/Box";
import { Checkbox } from "@proda-ai/ui-kit";

export const testIds = {
    checkboxSelectAll: "checkbox-select-all",
};

type CheckboxHeaderRendererProps = ICellRendererParams & {
    clearSelection: () => void;
    selectAll: () => void;
    checked: "all" | "some" | "none";
};

export const CheckboxHeaderRenderer: React.FC<CheckboxHeaderRendererProps> = ({
    clearSelection,
    selectAll,
    checked,
}) => {
    return (
        <Box
            sx={{
                width: "25px",
                display: "flex",
                alignItems: "center",
                height: "100%",
            }}
        >
            {checked === "all" ? (
                <Checkbox
                    checked={true}
                    onChange={() => {
                        clearSelection();
                    }}
                    label="Select all"
                    value="select-all"
                    data-testid={testIds.checkboxSelectAll}
                />
            ) : checked === "some" ? (
                <Checkbox
                    checked={true}
                    onChange={() => {
                        selectAll();
                    }}
                    indeterminate={true}
                    label="Select all"
                    value="select-all"
                    data-testid={testIds.checkboxSelectAll}
                />
            ) : (
                <Checkbox
                    checked={false}
                    onChange={selectAll}
                    label="Select all"
                    value="select-all"
                    data-testid={testIds.checkboxSelectAll}
                />
            )}
        </Box>
    );
};
